import PhoneModal from './PhoneModal';

export default PhoneModal;
